"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.brasilApi = exports.ibge = void 0;
const axios_1 = __importDefault(require("axios"));
const constants_1 = require("../assets/constants/constants");
const api = axios_1.default.create({
    baseURL: constants_1.API_URL,
});
exports.ibge = axios_1.default.create({
    baseURL: 'https://servicodados.ibge.gov.br/api/v1/',
});
exports.brasilApi = axios_1.default.create({
    baseURL: 'https://brasilapi.com.br/api/',
});
exports.default = api;
